import BudgetsPages from "../../../components/budgetsForm/pages";
    
const Budgets = (props: any) => {
    return <BudgetsPages {...props} persona="fleet-manager" />;
};

export default Budgets;